export default (function () {
  return {
    locationInput: document.querySelector('.locate__search-bar input[type="text"]'),
    selectBtn: document.querySelector('.locate__search-bar button'),
    resultsContainer: document.querySelector('.locate__search-results'),
    resultsGrid: document.querySelector('.locate__search-results-grid'),
    enterSearchStatus: 'idle',
    async init() {
      await this.initMap();
    },

    async fetchStoreData(){
      const apiEndpoint = document.querySelector('.locate').getAttribute('data-api');
      try {
        const res = await fetch(apiEndpoint);
        return res.json();
      } catch(err) {
        throw new Error('Could not fetch rep data', err.message);
      }
    },

    async fetchCitiesData() {
      const apiEndpointCities = document.querySelector('.cities').getAttribute('data-api');
      try {
        const res = await fetch(apiEndpointCities);
        return res.json();
      } catch (err) {
        throw new Error('Could not fetch cities data', err.message);
      }
    },

    async initMap() {
      const { Autocomplete } = await google.maps.importLibrary('places');

      const autocomplete = new Autocomplete(this.locationInput, {
        types: ['(regions)'],
      });

      const mapData = await this.fetchStoreData();
      const citiesData = await this.fetchCitiesData();

      autocomplete.setFields(['address_components', 'geometry', 'name']);

      const getAddressComponentValue = (result, componentType, oldApi) => {
        if (oldApi) {
          const component = result.address_components.find((c) => c.types.indexOf(componentType) !== -1);
          return component ? component.short_name : '';
        }
        const component = result.find((c) => c.types.indexOf(componentType) !== -1);
        return component ? component.shortText : '';
      };

      const isCitySearch = (inputLocation, oldApi) => {
        if (oldApi) {
          return inputLocation.address_components && inputLocation.address_components.length > 0 && inputLocation.address_components[0].types.includes('locality');
        }
        return inputLocation.length > 0 && inputLocation[0].types.includes('locality');
      };

      const getCityLongName = (result, oldApi) => {
        if (oldApi) {
          const city = result.address_components.find((c) => c.types.indexOf('locality') !== -1);
          return city ? city.long_name : '';
        }
        const city = result.find((c) => c.types.indexOf('locality') !== -1);
        return city ? city.longText : '';
      };

      const getZipcodeFromCity = (mapCitiesData, inputCity, inputProvince) => {
        const match = mapCitiesData.find((city) => city.state === inputProvince && city.city === inputCity);
        return match ? match.zipCode : null;
      };

      const getRepos = async (storeData, inputLocation) => {
        // New api is used by keyboard 'Enter', old is used by selecting item and clicking "Select" button
        // both versions have different structures, potential for a refactor in future but as of writing
        // autocomplete places api (new) is in "preview"
        const oldApi = !!inputLocation.address_components;

        const stores = [];

        const locationCountry = getAddressComponentValue(inputLocation, 'country', oldApi);
        const provinceCode = getAddressComponentValue(inputLocation, 'administrative_area_level_1', oldApi);
        let zipCode = getAddressComponentValue(inputLocation, 'postal_code', oldApi);

        // if searching a city, we need to match to zipcode and search on that zipcode
        if (isCitySearch(inputLocation, oldApi) && locationCountry === "US") {
          const city = getCityLongName(inputLocation, oldApi);
          zipCode = getZipcodeFromCity(citiesData, city, provinceCode);
        }

        // Build parallel arrays for the store IDs and destinations
        storeData.forEach(store => {
          const {
            storeid,
            category,
            name,
            zipCodes,
            states,
            provinceCodes,
            countryCodes,
            phone, 
            email,
          } = store.properties;
          stores.push({
            id: storeid,
            category,
            name,
            zipcode: zipCodes,
            state: states,
            provincecode: provinceCodes,
            countrycode: countryCodes,
            phone,
            email,
          });
        });

        const getDestinations = async () => {
          let lookupVar;
          let checkForValue;
          switch (locationCountry) {
          case 'US':
            // Get the location within the USA via postal/zip code
            lookupVar = zipCode ? 'zipcode' : 'state';
            checkForValue = zipCode ? Number(zipCode) : provinceCode;
            break;
          case 'CA':
            // Get the location within Canada
            lookupVar = 'provincecode';
            checkForValue = provinceCode;
            break;
          default:
            // Get the location around the world via country code
            lookupVar = 'countrycode';
            checkForValue = locationCountry;
          }

          return stores.filter((store) => store[lookupVar] !== undefined && store[lookupVar].includes(checkForValue));
        };

        const distancesList = await getDestinations();
        return distancesList.slice(0);
      };

      this.selectBtn.addEventListener('click', async () => {
        const place = autocomplete.getPlace();

        if (!place) {
          const autoCompleteInput = document.querySelector('.pac-target-input');
          autoCompleteInput.style.outlineColor = '#ee3a43';
          autoCompleteInput.focus();
          return;
        }

        const rankedStores = await getRepos(mapData.features, place);
        this.showStoresList(rankedStores);
      });

      this.locationInput.addEventListener('keydown', async (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();

          if (this.enterSearchStatus === 'searching') return;
          this.enterSearchStatus = 'searching';

          const autocompleteService = new google.maps.places.AutocompleteService();

          const request = {
            input: e.target.value,
            types: ['(regions)'],
          };
          await autocompleteService.getPlacePredictions(request, async (predictions) => {
            if (!predictions) {
              this.resultsContainer.setAttribute('data-display', 'error');
              return;
            }
            // Take the first prediction on enter
            const firstPrediction = predictions[0];
            e.target.value = firstPrediction.description;

            // Query the places api (new) to get the first prediction data
            const { Place } = await google.maps.importLibrary("places");
            const thePlace = new Place({
              id: firstPrediction.place_id,
            });

            await thePlace.fetchFields({
              fields: ["addressComponents"],
            });

            const rankedStores = await getRepos(mapData.features, thePlace.addressComponents);
            this.showStoresList(rankedStores);

          });

          this.enterSearchStatus = 'idle';
        }
      });
    },

    htmlCard({ category, name, phone, emailOrLink }) {
      const categoryOutput = category.join(', ');
      const contactLink = this.generateContactLink(emailOrLink);
      const html = `
        <span class="locate__category">${categoryOutput}</span>
        <div class="card-content">
          <div class="location-details">
            <p class="location__name">${name}</p>
            ${phone ? `<p>Telephone: ${phone}</p>` : ''}
            ${contactLink.url ? `<p>${contactLink.label}: ${emailOrLink}</p>` : ''}
          </div>
          <div class="actions">
            ${phone ? `<a href="tel:${phone}" class="btn btn--icon btn--cta btn--red btn--icon--phone--outline"><span>Call</span></a>` : ''}
            ${contactLink.url ? `<a href="${contactLink.url}" class="btn btn--icon btn--cta btn--red btn--icon--mail--outline"><span>${contactLink.label}</span></a>` : ''}
          </div>
        </div>
    `;
      return html;
    },

    showStoresList(stores) {
      this.resultsGrid.innerHTML = '';

      if (stores.length === 0) {
        this.resultsContainer.setAttribute('data-display', 'error');
        return;
      }

      this.resultsContainer.setAttribute('data-display', 'success');

      stores.forEach(store => {
        const { category, name, phone, email } = store;
        const locationCard = document.createElement('div');
        locationCard.classList.add('locate__card');
        locationCard.innerHTML = this.htmlCard({ category, name, phone, emailOrLink: email });
        this.resultsGrid.appendChild(locationCard);
      });

    },

    generateContactLink(input) {
      const emailRegex = /^[\w-.]+@([\w-]+.)+[\w-]{2,4}$/;

      if (!emailRegex.test(input)) {
        return {
          label: "Contact",
          url: input,
        };
      }
      return {
        label: "Email",
        url: `mailto:${input}`,
      };
    },
  };
})();
